import React, { useState, useEffect } from 'react';
import { getRol } from '../../../_utils/storage_handler';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Checkbox } from 'antd';
import {
  findOrdersEvent
} from '../../../_events/orders/find_order.event';
import { aproverOrdersEvent, deleteOrdersEvent, displayPDFOrderEvent, sectionOrdersEvent, deleteOrderDetailEvent } from '../../../_events/orders/order_box.event';
import { viewPDFColorEvent, viewPDFQrEvent, regroupEvent, readyOrderDetailEvent } from '../../../_events/orderDetail/orderDetail.event';

import { createProductWeightEvent } from '../../../_events/product_weight/product_weight.event';
import {
  buildProductWeightBoxBody,
  validatePercentBody,
  validateProductWeightBody
} from '../../../_events/product_weight/product_weight.input';

import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import CrudeBoxList from './crude_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import {
  buildOrderBoxBody,
  validateOrderBoxBody
} from '../../../_events/orders/order_box.input';
import { isNotViewer } from '../../../_utils/render_actions';
import { createClientPercentEvent, updateClientPercentEvent } from '../../../_events/client_percent/client_percent.event';
import ModalBarcode from './modal_barcode';
import ModalCreateAlert from '../weaving/modals/modal-create-alert';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const CrudeBox = () => {

  const in_process = 'CRUD';

  const [allChecked, setAllChecked] = useState(false);
  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderDetail, setOrderDetail] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openModalWeight, setOpenModalWeight] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);
  const [process_state, setProcess_state] = useState([]);
  const [product, setProduct] = useState([]);
  const [od_product, setOd_product] = useState([]);
  const [meter, setMeter] = useState('');
  const [customer_formulas, setCustomer_formulas] = useState([]);
  const [openModalProductWeight, setOpenModalProductWeight] = React.useState(false);

  const [openModaClientPercent, setOpenModaClientPercent] = React.useState(false);
  const [clientUpdate, setClientUpdate] = useState([]);
  const [defectPercent, setDefectPercent] = useState(5);

  const [totalAlisItems, setTotalAlisItems] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [totalMeters, setTotalMeters] = useState(0);
  const [totalMetersAlis, setTotalMetersAlis] = useState(0);

  const modalWeight = (orderDetail) => {
    setProduct(orderDetail.productPrice.product);
    setOd_product(orderDetail);
    setOpenModalWeight(true);
  }

  const createProductWeight = (body) => {
    createProductWeightEvent(orderDetail.productPrice.product.uuid, body.kilo, body.meter)
      .then(data => {
        loadOrders();
        message.success('Conversion registrada.')
      })
  };

  const setCloseModalWeight = () => {
    setOpenModalWeight(false);
    setMeter('');
    setProduct([]);
  }

  const regroup = (orderDetail, order) => {
    regroupEvent(orderDetail, order)
      .then((data) => {
        if (data.data !== undefined) {
          message.warning(data.data);
        } else {
          message.success('Producto agrupado');
          loadOrders();
        }
      })
      .catch((error) => {
        console.error(error);
      });

  }

  const updateClientPercent = (order) => {
    setOpenModaClientPercent(true);
    setClientUpdate(order.ordersDetail[0].productPrice.client);
  }

  const clientPercent = (body) => {
    const percent = body.percent;
    if (clientUpdate.clientPercent.length > 0) {
      updateClientPercentEvent(clientUpdate.clientPercent, percent)
        .then((data) => {
          message.success('Porcentaje actualizado');
          loadOrders();
        })
        .catch((error) => {
          console.error(error);
        });
    }
    else {
      createClientPercentEvent(clientUpdate, percent)
        .then((data) => {
          message.success('Porcentaje asignado');
          loadOrders();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  const viewQR = (orderDetail, order_uuid) => {
    if (orderDetail.productPrice.product.productWeight.length > 0) {
      setOpenPDF(true);
      viewPDFQrEvent(orderDetail, order_uuid)
        .then((data) => {
          setPDF(data.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    else {
      message.warning('El producto seleccionado no tiene conversion');
    }
  }

  const viewColor = (orderDetail) => {

    viewPDFColorEvent(orderDetail)
      .then((data) => {
        if (data.data) {
          setOpenPDF(true);
          setPDF(data.data);
        }
        else {
          message.warning('Al parecer hay un problema con la formula seleccionada');
        }
      })
      .catch((error) => {
        console.error(error.message);
      });

  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClosePDF = () => {
    setOpenPDF(false);
    setPDF(null);
  };

  const loadOrders = (loading = true) => {
    if(loading) setAllChecked(false);
    if(loading) setLoading(true);
    findOrdersEvent('CRUD')
      .then(data => {
        let orders_list = [];
        let process_list = [];
        let customer_formulas = [];
        data.list.forEach(obj => {
          if (obj.uuid != null && obj.id) {
            orders_list.push(obj);
          } else if (obj.name != null && obj.cod != null) {
            process_list.push(obj);
          } else if (obj.id != null && obj.machine != null) {
            customer_formulas.push(obj);
          }
        });
        setOrders(orders_list);
        countItemsAndMeters(orders_list);

        process_list.sort((a, b) => (a.cod === 'DEFE') ? -1 : ((b.cod === 'DEFE') ? 1 : 0));
        setProcess_state(process_list);
        setCustomer_formulas(customer_formulas);
        if(loading) setLoading(false);
      })
      .catch(err => {
        message.error(err.message);
        if(loading) setLoading(false);
      });
  }

  

  const countItemsAndMeters = (orders) => {
    let totalI = 0;
    let meters = 0;

    let totalAlisI = 0;
    let metersAlis = 0;

    orders.forEach(o => {
      const crudOrdersCount = o.ordersDetail.filter((od) => od.cod_process === 'CRUD').length;
      const alisOrdersCount = o.ordersDetail.filter((od) => od.cod_process === 'ALIS').length;

      o.ordersDetail.forEach(od => {
        if (od.cod_process === 'ALIS') {
          if (od.type_quantity === 'MTS') {
            metersAlis += od.quantity;
          } else {
            metersAlis += ((od.quantity * od.productPrice.product.productWeight[0].meter) / od.productPrice.product.productWeight[0].kilo)
          }

        } else {
          if (od.type_quantity === 'MTS') {
            meters += od.quantity;
          } else {
            meters += ((od.quantity * od.productPrice.product.productWeight[0].meter) / od.productPrice.product.productWeight[0].kilo)
          }
        }
      });
  
      totalI += crudOrdersCount;
      totalAlisI += alisOrdersCount;
    });

    setTotalItems(totalI);
    setTotalAlisItems(totalAlisI);
    setTotalMetersAlis(metersAlis);
    setTotalMeters(meters);
  }

  const setEditOrder = (o, p) => {
    setOrder({ uuid: p.uuid, order: o });
    setOrderDetail(o);
    handleOpen();
  }

  const aprove = () => {
    let selectedOptions = [];
    orders.forEach((order) => {
      let count = 0;
      order.ordersDetail.forEach((orderDetail) => {
        const selectElement = document.querySelector(`select[data-uuid="${orderDetail.uuid}"]`);
        if (selectElement) { selectedOptions.push(selectElement.value); }
        else { count = 1; }
      });
      if (count > 0) { selectedOptions.push(`all-defect-i//${order.uuid}`); count = 0; }
    });
    aproverOrdersEvent(orders, selectedOptions, in_process)
      .then(data => {
        if (data.data.PDF !== null) {
          setOpenPDF(true);
          setPDF(data.data.PDF)
          loadOrders();
        }
        if (data.data.res !== null) {
          message.warning(data.data.res);
        }


      })
      .catch(err => {
        message.error(err.message);
      });
  };


  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
      .then(data => {
        message.success('Orden eliminada');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const section_product = (orderDetail, quantity_section, quantity_order, order) => {
    sectionOrdersEvent(orderDetail, quantity_section, quantity_order, order, in_process)
      .then(data => {
        message.success('Producto recortado.');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const checkAll = () => {
    let check = allChecked;
    let ordersNew = [...orders];
    ordersNew.forEach(element => {
      element.checked = check ? 0 : 1;
    });
    setAllChecked(!check);
    setOrders(ordersNew);
  }

  const displayPDF = (order) => {
    if (!order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
        .then(data => {

          setPDF(data.data.toAproveJSON);
          setOpenPDF(true);
        })
        .catch(err => {
          message.error(err.message);
        });
    }
  }

  const deleteOrderDetail = (detail) => {

    deleteOrderDetailEvent(detail.uuid)
      .then(data => {
        message.success('Producto eliminado');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  const readyOrderDetail = (detail) => {
    readyOrderDetailEvent(detail.uuid)
      .then(data => {
        message.success('Producto preparado');
        loadOrders(false);
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  useEffect(() => {
    loadOrders();
  }, []);

  let rol = getRol();

  return (
    <Grid container spacing={1} >
      <Grid item xs={12} md={12}>
        <Typography variant="h6" component="h6">
          Bandeja de Crudo
        </Typography>
        <hr />
        {
          loading ? (
            <PrimaryProgress />
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={6} md={6}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                  <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                  <Chip label={`Entregas INMEDIATAS: ${orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                  <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                </div>
              </Grid>
              <Grid item xs={6} md={6}>
                <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%' }}>
                  <BasicPopconfirm
                    label='Aprobar órdenes'
                    title='¿Seguro/a que deseas aprobar todas las órdenes seleccionadas?'
                    onConfirm={() => { isNotViewer(rol) ? aprove() : alert('Usuario informativo') }}
                  />
                  <ModalBarcode loadOrders={loadOrders} />

                  <div style={{ margin: '0 10px' }}>
                    <ModalCreateAlert />
                  </div>

                </div>
              </Grid>
              <Grid item xs={12} md={12}>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
                  <Checkbox
                    style={{ marginRight: '55px' }}
                    checked={allChecked}
                    onClick={event => {
                      event.stopPropagation();
                    }}
                    onChange={() => {
                      checkAll();
                    }}>
                  </Checkbox>
                </div>
              </Grid>
              <Grid item xs={12} md={12}>
                <CrudeBoxList
                  data={orders}
                  process={process_state}
                  defectPercent={defectPercent}
                  totalItems={totalItems}
                  totalAlisItems={totalAlisItems}
                  totalMetersAlis={totalMetersAlis}
                  totalMeters={totalMeters}
                  readyOrderDetail = { (orderDetail) => readyOrderDetail(orderDetail) }
                  viewQR={(orderDetail, order_uuid) => viewQR(orderDetail, order_uuid)}
                  viewColor={(orderDetail) => viewColor(orderDetail)}
                  regroup={(orderDetail, o) => regroup(orderDetail, o)}
                  modalWeight={(product) => modalWeight(product)}
                  updateClientPercent={(order) => updateClientPercent(order)}
                  setOpenModalProductWeight={setOpenModalProductWeight}
                  setOrderDetail={setOrderDetail}
                  setEditOrder={(o, p) => setEditOrder(o, p)}
                  deleteOrderDetail={(detail) => deleteOrderDetail(detail)}
                  updateDataOrdersChecked={(d) => {
                    let index = orders.findIndex(o => o.uuid === d.uuid);
                    if (index === -1) {
                      message.error('No se logró seleccionar');
                    } else {
                      let orders_updated = [...orders];
                      orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                      setOrders(orders_updated);
                    }
                  }}
                  deleteOrder={(o) => { isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo') }}
                  displayPDF={(o) => displayPDF(o)}
                />
              </Grid>
            </Grid>
          )
        }
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={6} >
              <TextField
                error={false}
                required
                style={{ width: '100%' }}
                id="orderD_box_product"
                label="REF. PRODUCTO"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.productPrice.product.ref : ''}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                error={false}
                required
                style={{ width: '100%' }}
                id="orderD_box_color"
                label="COLOR"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.color.cod : ''}
                disabled={true}
              />
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={6} >
              <TextField
                error={false}
                required
                style={{ width: '100%' }}
                id="orderD_box_quantity"
                label="MEDIDA ACTUAL"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.quantity : ''}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                error={false}
                required
                style={{ width: '100%' }}
                id="orderD_box_type_quantity"
                label="UNIDADES"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.type_quantity : ''}
                disabled={true}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                error={false}
                required
                style={{ width: '100%', display: 'none' }}
                id="orderD_box_price"
                label="PRECIO"
                variant="outlined"
                size="small"
                defaultValue={orderDetail ? orderDetail.price : ''}
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <TextField
                error={false}
                required
                style={{ width: '100%' }}
                id="orderD_box_section"
                label="MEDIDA DE CORTE"
                variant="outlined"
                size="small"
              />


            </Grid>
            <Grid item xs={12} md={12}>
              <Button size='small' variant='contained' onClick={() => {
                let index = orders.findIndex(o => o.uuid === order.uuid);
                if (index === -1) {
                  message.error('No se logró seleccionar');
                } else {
                  let orders_updated = [...orders];
                  let odIndex = orders_updated[index].ordersDetail.findIndex(p => p.uuid === order.order.uuid);
                  if (odIndex === -1) {
                    message.error('No se logró seleccionar detalle');
                  } else {
                    try {
                      let body = buildOrderBoxBody();
                      validateOrderBoxBody(body);
                      section_product(orderDetail, body.section, orderDetail.quantity, order);
                      handleClose();
                    } catch (err) {
                      message.error(err.message);
                    }
                  }
                }
              }}>Recortar</Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>


      {/* modal para crear la conversion de peso */}
      <Modal
        open={openModalProductWeight}
        onClose={() => setOpenModalProductWeight(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">
            <div style={{ textAlign: 'center' }}>
              <p><b>! Registro de conversion !</b></p>
            </div>

            <p>Por favor introduzca la conversion</p>
          </Typography>
          <TextField
            label="Kilo(s)"
            variant="outlined"
            type="number"
            id="kilo"
            fullWidth
            required
            inputProps={{ step: 0.01 }}
          />
          <br /><br />
          <TextField
            label="Metro(s)"
            variant="outlined"
            type="number"
            id="meter"
            fullWidth
            required
            inputProps={{ step: 0.01 }}
          />


          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                try {
                  let body = buildProductWeightBoxBody();
                  validateProductWeightBody(body);
                  setOpenModalProductWeight(false);
                  createProductWeight(body);

                } catch (err) {
                  message.error(err.message);
                }

              }}
            >
              Registrar
            </Button>
          </div>
        </Box>
      </Modal>



      {/* modal para crear el % de un  cliente */}
      <Modal
        open={openModaClientPercent}
        onClose={() => setOpenModaClientPercent(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {!clientUpdate ? <>Cargando...</> :
          <Box sx={style}>
            <Typography variant="" component="">
              <div style={{ textAlign: 'center' }}>
                <p><b>Porcentaje de cliente</b></p>
              </div>

              <p>Por favor introduzca el porcenaje para el cliente: {clientUpdate.name}{clientUpdate.clientPercent ?
                clientUpdate.clientPercent.length > 0 ?
                  ` (${clientUpdate.clientPercent[0].percent}%)`
                  :
                  ` (${defectPercent}%)`
                :
                ''}</p>
            </Typography>
            <TextField
              label="Porcentaje"
              variant="outlined"
              type="number"
              id="percent"
              fullWidth
              required
              inputProps={{ step: 0.01 }}
            />

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  try {
                    validatePercentBody(document.getElementById('percent').value);
                    const body = {
                      percent: document.getElementById('percent').value,
                      client: clientUpdate
                    }
                    clientPercent(body);
                    setOpenModaClientPercent(false);
                  } catch (err) {
                    message.error(err.message);
                  }

                }}
              >
                Crear
              </Button>
            </div>
          </Box>
        }
      </Modal>


      <Modal
        open={openPDF}
        onClose={handleClosePDF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={1}>
            {
              !pdf ? <>Cargando...</> :
                <Grid item xs={12} md={12}>
                  <object width="100%" height="600px"
                    data={`data:application/pdf;base64,${pdf}`}
                    type="application/pdf" className="internal"
                  >
                    <embed
                      src={`data:application/pdf;base64,${pdf}`}
                      type="application/pdf"
                    />
                  </object>
                </Grid>
            }
          </Grid>
        </Box>
      </Modal>






    </Grid>
  );
}

export default CrudeBox;
